// export const BASE_URL = 'http://localhost/iscon-attendx/public/api/'
// export const IMAGE_URL = 'http://localhost/iscon-attendx/public/images/'

export const BASE_URL = 'http://attback.appitrace.com/public/api/'
export const IMAGE_URL = 'http://attback.appitrace.com/public/images/'

// Admin Auth
export const LOGIN_URL = BASE_URL + 'login'
export const LOGOUT_URL = BASE_URL + 'logout'
export const FORGOT_PASSWORD_URL = BASE_URL + 'forgot-password'
export const FORGOT_PASSWORD_RESET_URL = BASE_URL + 'reset-password'
export const GET_SETTINGS = BASE_URL + 'settings'
export const CHANGE_PASSWORD_URL = BASE_URL + 'change-password'
export const EDIT_PROFILE_URL = BASE_URL + 'edit-profile'
export const GET_PROFILE_URL = BASE_URL + 'my-profile'